import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-content d-flex mt-4 mb-6 align-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "История", -1)
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = ["href"]

import { onMounted, ref } from 'vue';
import { useFeedbackStore } from '@/stores/feedback';
import { useAccountStore } from '@/stores/account';
import dayjs from 'dayjs';
import VDialogHeader from './VDialogHeader.vue';
import VTable from '../VTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackReportHistory',
  setup(__props) {

const accountStore = useAccountStore()

const columns = {
  date: { title: "Дата" },
  studentsCount: { title: "Количество опрошенных" },
  url: { title: "Ссылка", width: 20 }
}

const pending = ref(false)
const feedbackStore = useFeedbackStore()
const host = window.location.origin

onMounted(() => {
  if (feedbackStore.polls.length === 0) {
    feedbackStore.requestPolls()
  }
})

const copy = (str: string) => {
  navigator.clipboard.writeText(str)
}

const createNewPoll = async () => {
  pending.value = true
  try {
    await feedbackStore.createPoll()
  } catch (e) {
    
  } finally {
    pending.value = false
  }

}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(VDialogHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Архив отчетов обратной связи")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_unref(accountStore).isDirector)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            color: "primary",
            "prepend-icon": "mdi-plus",
            class: "ml-auto px-5",
            disabled: pending.value,
            onClick: createNewPoll
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Новый отчет ")
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(VTable, {
      columns: columns,
      data: _unref(feedbackStore).polls,
      class: "mb-4"
    }, {
      date: _withCtx(({ cell }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(cell).format("DD MMMM YYYY")), 1)
      ]),
      url: _withCtx(({ cell }) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            href: (_unref(host) + cell),
            target: "_blank",
            class: "link"
          }, _toDisplayString(_unref(host) + cell), 9, _hoisted_4),
          _createVNode(_component_v_btn, {
            icon: "mdi-content-copy",
            class: "ml-2",
            size: "small",
            flat: "",
            onClick: ($event: any) => (copy(_unref(host) + cell))
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}
}

})